import React from 'react'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ProgressBar from '../../components/ProgressBar';
import Layout from '../../components/Layout'
import Button from '../../components/Button'

import constants from '../../config/constants'
import email from '../../assets/images/emailSuccess.svg'

const Main = styled.div`
  padding-top: 2rem;
`

const MainImg = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  padding: 3rem 0 2rem;
  text-align: center;
`

const ConfirmEmailSuccess = (props) => {

  return (
    <Layout title={'ข้อมูลส่วนตัว'} backIcon={true} onClick={() => props.history.goBack()}>
      <ProgressBar percent={25}/>
      <Main>
        <MainImg>
          <LazyLoadImage
            alt=''
            height={150}
            visibleByDefault={true}
            src={email}
            width={150} />
        </MainImg>
        <MainDetail>
          <h4>ยืนยันอีเมลสำเร็จ</h4>
        </MainDetail>
        <Button
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ทำรายการต่อ'}
          disabled={false}
          onClick={() => props.history.push('/upload-document')}
          />
      </Main>
    </Layout>
  )
}

export default ConfirmEmailSuccess
